module.exports = __webpack_public_path__ + "static/media/cafe_terrasa.0cb327f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/RestaurantAndCafe/images/cafe_terrasa.jpg
// module id = 358
// module chunks = 0